import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import App from './App';
import './index.css';

// Static-preview deploys are served from a deep path (S3/sites proxy), so we
// use HashRouter there. Local dev and the real Railway deploy keep BrowserRouter.
const Router = import.meta.env.VITE_STATIC_PREVIEW === '1' ? HashRouter : BrowserRouter;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>
);
